/**
 * Copyright © 2026 Adnuntius AS.
 *
 * Eager aggregate for the advertising feature modules.
 */
import {NgModule} from '@angular/core';

import {TeamModule} from '../admin/team/team.module';
import {CreativeModule} from '../creative/creative.module';
import {LineItemModule} from '../line-item/line-item.module';
import {OrderModule} from '../order/order.module';
import {GetCampaignQrCodeModalComponent} from '../print-line-item/get-campaign-qr-code-modal.component';
import {PrintLineItemEditPageComponent} from '../print-line-item/print-line-item-edit-page.component';
import {PrintLineItemListPageComponent} from '../print-line-item/print-line-item-list-page.component';
import {RetailProductConversionTrackingModalComponent} from '../retail-product/retail-product-conversion-tracking-modal.component';
import {RetailProductCreativesModalComponent} from '../retail-product/retail-product-creatives-modal.component';
import {RetailProductListFiltersComponent} from '../retail-product/retail-product-list-filters.component';
import {RetailProductListPageComponent} from '../retail-product/retail-product-list-page.component';
import {AdvertisingSharedModule} from './advertising-shared.module';

const ADVERTISING_FEATURE_MODULES = [
  AdvertisingSharedModule,
  CreativeModule,
  LineItemModule,
  OrderModule,
    GetCampaignQrCodeModalComponent,
    PrintLineItemEditPageComponent,
    PrintLineItemListPageComponent,
  RetailProductConversionTrackingModalComponent,
  RetailProductCreativesModalComponent,
  RetailProductListFiltersComponent,
  RetailProductListPageComponent,
  TeamModule
];

@NgModule({
  imports: ADVERTISING_FEATURE_MODULES,
  exports: ADVERTISING_FEATURE_MODULES
})
export class AdvertisingModule {
}
